import type { State } from '../../../reducers';

export const getShowPositionSharingDialog = (state: State): boolean => state.positionSharing.showPositionSharingDialog;
